package devxertech.com.pages.portfolio.zone

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.core.Page
import devxertech.com.seo.PageMetadataForCurrentRoute
import com.varabyte.kobweb.silk.theme.breakpoint.rememberBreakpoint
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import devxertech.com.pages.commons.CommonHeader
import devxertech.com.pages.commons.ZoneArrow
import devxertech.com.pages.dashboard.footerSection.HomepageFooter
import devxertech.com.pages.dashboard.ratingSection.RatingSection
import devxertech.com.theme.toSitePalette
import devxertech.com.utils.Res

@Page("/zone")
@Composable
fun ZonePage() {
    PageMetadataForCurrentRoute()
    val breakpoint = rememberBreakpoint()
    val sitePalette = ColorMode.current.toSitePalette()
    Column(
        modifier = Modifier.fillMaxSize().backgroundColor(sitePalette.bodyBackgroundSecondary.rgb)
    ) {
        CommonHeader(
            mainHeadingAsH1 = true,
            image = Res.Image.zone_header,
            imageAlt = "Zone360 soccer coaching application",
            breakpoint = breakpoint,
            headingText = "Zone 360",
            descriptionText = "Zone360 is an AI-powered application designed to enhance coaching skills in sports (soccer).\n",
            startProject = false, careerHeight = true, careerFontSize = true, heightModification = true, commonPortfolioChanges = true
        )
        ZoneArrow("Zone360")
        CommonZoneAbout(image = Res.Image.zone_icon, title = "Zone360", description = "Zone360 is an AI-powered application designed to enhance coaching skills in sports (soccer). By analyzing audio from training sessions and matches, " +
                "it provides personalized feedback and insights to coaches and players. ")
        CommonAppView(image = Res.Image.zone_png, breakpoint)
        CommonWebView(image = Res.Image.zone_webview, breakpoint)
        RatingSection(breakpoint)
        HomepageFooter(breakpoint)
    }
}
